// import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import sidebarReducer from './sidebarSlice';
// import dataReducer from './dataSlice';
// import yearSlice from './yearSlice';

// const persistConfig = {
//   key: 'root',
//   storage,
// };

// const rootReducer = combineReducers({
//   sidebar: sidebarReducer,
//   data: dataReducer,
//   financialYear : yearSlice,
// });

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//   reducer: persistedReducer,
// });

// const persistor = persistStore(store);

// export { store, persistor };

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// import { compressTransform } from 'redux-persist-transform-compress';
import compress from 'redux-persist-transform-compress';
import sidebarReducer from './sidebarSlice';
import dataReducer from './dataSlice';
import yearSlice from './yearSlice';
import tempPolicySlice from './tempPolicySlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['sidebar', 'financialYear','policyData'], 
  transforms: [compress()], 
};

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  data: dataReducer, 
  financialYear: yearSlice,
  policyData: tempPolicySlice, 
});


const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }),
});

const persistor = persistStore(store);

export { store, persistor };
